import React, { useMemo } from "react";
import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";
import { useParams } from "react-router-dom";

const systemLabels = {
  koordinaattori: "Koordinaattori",
  kuntotutkija: "Kuntotutkija",
  rakennustekniikka: "Rakennustekniikka",
  lvia: "LVIA-järjestelmät",
  sahko: "Sähköjärjestelmät",
};

export default function TeamBlockNimikkeella({ data = {}, onChange }) {
  const { assignments } = useReportTemplateContext();
  const { templateName } = useParams();

  const defaultMode = templateName === "wk3" ? "ammattinimike" : "yritys";

  const getMode = (systemKey, userId) =>
    data?.modes?.[systemKey]?.[userId] ?? defaultMode;

  const toggleMode = (systemKey, userId) => {
    const current = getMode(systemKey, userId);
    const next = current === "yritys" ? "ammattinimike" : "yritys";
    onChange({
      ...data,
      modes: {
        ...(data.modes ?? {}),
        [systemKey]: {
          ...(data.modes?.[systemKey] ?? {}),
          [userId]: next,
        },
      },
    });
  };

  const rows = useMemo(() => {
    if (!assignments) return [];
    return Object.keys(assignments).map((systemKey) => {
      const users = (assignments[systemKey] || []).map((u) => ({
        id: u.id,
        name: u.nimi || u.sahkoposti || "Tuntematon",
        yritys: u.yritys || "",
        ammattinimike: u.ammattinimike || "",
      }));
      return { role: systemLabels[systemKey] || systemKey, systemKey, users };
    });
  }, [assignments]);

  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Rooli</th>
          <th>Nimi</th>
          <th>Selite</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.systemKey}>
            <td>{row.role}</td>
            <td>
              {row.users.length === 0 ? (
                <span className="text-muted">Ei käyttäjiä</span>
              ) : (
                row.users.map((u) => <div key={u.id}>{u.name}</div>)
              )}
            </td>
            <td>
              {row.users.length === 0 ? (
                <span className="text-muted">–</span>
              ) : (
                row.users.map((u) => {
                  const mode = getMode(row.systemKey, u.id);
                  const value = mode === "yritys" ? u.yritys : u.ammattinimike;
                  return (
                    <div key={u.id} className="d-flex align-items-center gap-2 mb-1">
                      <span className="text-muted small">{value || "–"}</span>
                      <button
                        className="btn btn-outline-secondary py-0 px-1"
                        style={{ fontSize: "0.7rem", lineHeight: 1.4 }}
                        title={mode === "yritys" ? "Vaihda ammattinimikkeeseen" : "Vaihda yrityksen nimeen"}
                        onClick={() => toggleMode(row.systemKey, u.id)}
                      >
                        {mode === "yritys" ? "Yritys" : "Nimike"}
                      </button>
                    </div>
                  );
                })
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
